import { render, staticRenderFns } from "./forecasts.vue?vue&type=template&id=437e53dd&%23default=true"
import script from "./forecasts.vue?vue&type=script&lang=js"
export * from "./forecasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports